import { useContext } from "react";
import { AppContext } from "../../App";
import "./style.css";

function CategoriesMenu1() {
	const { courses, getTranslatedString, category, setCategory, settings } = useContext(AppContext);
	const isOnePage = (settings.website.products_loading_type || "onepage") === "onepage";

	const scrollProducts = (category) => {
		console.log("scrollProducts");
		const scrollContainer = document.getElementById("main");
		const header = document.getElementById("header");
		const menu = document.getElementsByClassName("categories-menu-1-container")[0];
		const element = document.getElementById("category-" + category.id);
		if (!scrollContainer || !header || !element) return;

		const menuHeight = menu ? menu.offsetHeight : 0;
		console.log(
			element.offsetTop,
			header.offsetHeight,
			menuHeight,
			element.offsetTop - header.offsetHeight - menuHeight
		);
		scrollContainer.scrollTo({
			behavior: "smooth",
			top: element.offsetTop - header.offsetHeight - menuHeight,
		});
	};

	return (
		<div className="categories-menu-1-container screen-container">
			<div className="categories-menu-1">
				{courses.map((course, i) =>
					course.categories.map(
						(c, n) =>
							c.products.length > 0 && (
								<button
									key={n}
									onClick={() => {
										if (isOnePage) scrollProducts(c);
										else setCategory(c);
									}}
									id={"category-button-" + c.id}
									className={category.id == c.id ? "active" : ""}
								>
									{settings.website.show_category_images == 1 && c.img && (
										<img className="category-icon" src={c.img} alt="" />
									)}
									{getTranslatedString(c, "name")}
								</button>
							)
					)
				)}
			</div>
		</div>
	);
}

export default CategoriesMenu1;
